import { forwardRef } from 'react';

import type { IconProps } from './types';

export const Gif = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <g clipPath="url(#clip0_637_3421)">
      <path
        d="M8.21169 12.4967C8.62977 12.428 9.11158 12.3887 9.60255 12.3887C9.64612 12.3887 9.68962 12.389 9.73305 12.3897L9.72646 12.3896L10.4871 17.2893C9.72184 17.8478 8.72767 18.4598 6.71905 18.7847C3.08212 19.3736 0.61839 17.4259 0.0876248 14.0013C-0.441313 10.5933 1.45195 7.76771 5.0215 7.18895C6.5492 6.94248 7.80737 7.15571 8.70276 7.54894C8.70276 8.54033 8.27352 9.72188 7.46952 10.3551C6.86399 10.0717 6.15414 9.99512 5.42397 10.1133C3.81318 10.3736 3.05165 11.6086 3.33318 13.4225C3.61009 15.2031 4.7455 16.1659 6.2732 15.9195C6.62212 15.8622 6.91844 15.7976 7.17876 15.7201L6.73844 12.8733C7.15251 12.7229 7.64828 12.5918 8.15873 12.5035L8.21261 12.4958L8.21169 12.4967ZM12.6379 15.877C12.0705 15.8369 11.5463 15.7549 11.0376 15.6328L11.1037 15.6462L11.7739 5.82739L11.8514 4.68922C12.5059 4.65507 13.0006 4.65045 13.3357 4.67445C13.6708 4.69845 14.1831 4.77598 14.8708 4.90522L14.8025 5.89754L14.1222 15.8631C13.8764 15.8889 13.5912 15.9035 13.3026 15.9035C13.0686 15.9035 12.8369 15.8939 12.6078 15.875L12.6379 15.877H12.6379ZM23.521 11.9751L19.3653 11.2274L19.0265 13.188L22.7355 13.8554C22.7586 14.3133 22.7133 14.7757 22.6339 15.2317C22.5533 15.7253 22.4271 16.1659 22.2563 16.5836L22.2711 16.5425L18.5622 15.8761L17.9641 19.3404C17.4279 19.3386 16.9044 19.2903 16.3956 19.1994L16.4502 19.2074C15.8867 19.101 15.3949 18.9615 14.922 18.7835L14.9844 18.8041L16.8582 7.95228L23.9936 9.23722C24.0176 9.69416 23.9715 10.1566 23.8958 10.596C23.8136 11.0695 23.7019 11.52 23.521 11.9751V11.9751Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_637_3421">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

export default Gif;
